var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5586 60V33.5167H56.4453M32.1336 60H56.4453V42.4167",
    stroke: "#4478FE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0781 44.3433L38.9698 51.235L47.9248 42.2817M33.0348 26.8117C33.0348 25.0051 33.7524 23.2725 35.0299 21.9951C36.3073 20.7177 38.0399 20 39.8465 20C41.653 20 43.3856 20.7177 44.663 21.9951C45.9405 23.2725 46.6581 25.0051 46.6581 26.8117V33.5167M33.0381 26.67V33.5167",
    stroke: "#4478FE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4805 74.2767C42.1877 76.818 33.2548 76.2677 25.3366 72.7275C17.4185 69.1873 11.0518 62.8972 7.41601 55.0226C3.78019 47.1479 3.12167 38.2223 5.56244 29.8993C8.00321 21.5763 13.3778 14.42 20.6907 9.75611C28.0035 5.09219 36.7589 3.23679 45.3349 4.53361C53.9109 5.83042 61.7263 10.1916 67.3332 16.8091C72.9401 23.4267 75.9585 31.8522 75.8293 40.5247C75.7001 49.1972 72.432 57.5291 66.6305 63.9767",
    stroke: "#4478FE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.3d9186d6ecadcd94c16ed071e80e1755.svg";
export { ForwardRef as ReactComponent };